// extracted by mini-css-extract-plugin
export var root = "PlasmicPost-module--root--X-eU4";
export var box__syXgy = "PlasmicPost-module--box__syXgy--3ZBcI";
export var postHeader = "PlasmicPost-module--postHeader--2eTXT";
export var box___140B8 = "PlasmicPost-module--box___140B8--3RER5";
export var container = "PlasmicPost-module--container--1iB4B";
export var box__xzIp6 = "PlasmicPost-module--box__xzIp6--1o8kL";
export var authorBio = "PlasmicPost-module--authorBio--Av_Km";
export var svg = "PlasmicPost-module--svg--3iwUT";
export var box__zIkXj = "PlasmicPost-module--box__zIkXj--353mu";
export var previousPost = "PlasmicPost-module--previousPost--jGAd2";
export var nextPost = "PlasmicPost-module--nextPost--1N1S5";
export var footer = "PlasmicPost-module--footer--2BFa1";